import { render, staticRenderFns } from "./ediDocWindow.vue?vue&type=template&id=5fb3e028&"
import script from "./ediDocWindow.vue?vue&type=script&lang=js&"
export * from "./ediDocWindow.vue?vue&type=script&lang=js&"
import style0 from "./ediDocWindow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fb3e028')) {
      api.createRecord('5fb3e028', component.options)
    } else {
      api.reload('5fb3e028', component.options)
    }
    module.hot.accept("./ediDocWindow.vue?vue&type=template&id=5fb3e028&", function () {
      api.rerender('5fb3e028', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/leadPage/ediDocWindow.vue"
export default component.exports